// extracted by mini-css-extract-plugin
export default {"overlay":"Menu_overlay__1-eCS","listItem":"Menu_listItem__GNRIz","listText":"Menu_listText__+Q9kL","phoneLink":"Menu_phoneLink__3Htc+"};